window.CustomSelect = (function () {

    var init = function (selectors) {
        if (globalAppSettings.isMobileDevice && window.Mobile) {
            return;
        }

        if ($.fn.niceSelect) {
            var selectorsLength = selectors.length;

            for (var i = 0; i < selectorsLength; i++)
                $(selectors[i]).niceSelect();
        } else {
            app.console.log('FAILED TO INIT CUSTOM SELECTBOX');
        }
    };

    var update = function (selectors) {
        if (globalAppSettings.isMobileDevice && window.Mobile) {
            return;
        }

        if ($.fn.niceSelect) {
            var selectorsLength = selectors.length;

            for (var i = 0; i < selectorsLength; i++) {
                $(selectors[i]).niceSelect('update');
            }
        } else {
            app.console.log('FAILED TO UPDATE CUSTOM SELECTBOX');
        }
    };

    var destroy = function (selectors) {
        if ($.fn.selectize) {
            var selectorsLength = selectors.length;

            for (var i = 0; i < selectorsLength; i++) {
                $(selectors[i]).niceSelect('destroy');
            }
        } else {
            app.console.log('FAILED TO DESTROY CUSTOM SELECTBOX');
        }
    };

    return {
        init: init,
        update: update,
        destroy: destroy
    };
}());